import { api, formHeaders } from "@";
// Fetches general settings data
export const getGeneralSettings = () => api.get(`/api/AdminWebsiteSettings`);

// Saves the general settings data
export const saveGeneralSettings = (data) =>
  api.post(`/api/AdminWebsiteSettings`, data, formHeaders);
